import type { IWidgetBanksPageContentFilter } from '~/components/widget/banks-page/content-filter'
import type { IHeroBanner } from '~/components/widget/hero-banner/types'
import type { IWidgetAdsBlock } from '~/components/widget/ads-block'
import type { IBankUrls } from '~/components/entity/bank'

export const seo = {
  title: 'page.banks.mocks.seo_title',
  ogTitle: 'page.banks.mocks.og_title'
}

export const categories: IWidgetBanksPageContentFilter[] = [
  { label: 'page.banks.mocks.categories.all', value: 'all' },
  { label: 'page.banks.mocks.categories.individuals', value: 'individuals' },
  { label: 'page.banks.mocks.categories.legals', value: 'legals' },
  { label: 'common.credits', value: 'credits' },
  { label: 'common.deposits', value: 'deposits' },
  { label: 'page.banks.mocks.categories.debit_cards', value: 'debit_cards' },
  { label: 'common.credit_cards', value: 'credit_cards' }
]

export const heroBanner: IHeroBanner = {
  heading: 'common.banks_of_kyrgyzstan',
  text: 'page.banks.mocks.hero_banner.text',
  image: '/images/photostock/banks-page-banner-image.png'
}

export const ctaBanner: IWidgetAdsBlock = {
  heading: 'page.banks.mocks.cta_banner.heading',
  text: 'page.banks.mocks.cta_banner.text',
  subtext: 'page.banks.mocks.cta_banner.subtext',
  image: '/images/banks/bakai-logo.png',
  url: '/bank/bakai/cards/208',
  action: {
    type: 'internal'
  }
}

export const ctaBannerDeposit: IWidgetAdsBlock = {
  heading: 'page.banks.mocks.cta_banner_deposit.heading',
  text: 'page.banks.mocks.cta_banner_deposit.text',
  url: '#lead-request-form',
  type: 'internal'
}

export const navItems = [
  { name: 'common.about_bank', link: '#about' },
  { name: 'common.credits', link: 'credits' },
  { name: 'common.deposits', link: 'deposits' },
  { name: 'common.bank_cards', link: 'cards' },
  { name: 'common.vacancies', link: 'vacancies' },
  { name: 'common.news', link: 'news' },
  { name: 'common.exchange_rates', link: 'rates' },
  { name: 'common.branches', link: 'branches' },
  { name: 'common.atms', link: 'atms' },
  { name: 'common.money_transfers', link: 'money_transfers' }
]

export const bankListItemLinks: IBankUrls[] = [
  { name: 'common.credits', url: '/credits', type: 'credits_count' },
  { name: 'common.deposits', url: '/deposits', type: 'deposits_count' },
  { name: 'common.bank_cards', url: '/cards', type: 'cards_count' },
  { name: 'common.vacancies', url: '/vacancies', type: 'vacancies_count' },
  { name: 'common.news', url: '/news', type: 'news_count' }
]

export default {
  seo,
  categories,
  heroBanner,
  ctaBanner,
  navItems,
  bankListItemLinks
}
